/**
 * PRACTICE FIELD (sandlot) — realism pass (2026-11-04). The flat-coloured
 * block forts become a real practice ground: a chalk football pitch between
 * the forts, log-palisade forts with plank decks and a painted practice goal,
 * nailed crates, ISO-container skins on the metal cover, square hay bales on
 * the low cover, a wall of numbered shooting targets with range signage, and
 * a grandstand, scoreboard and floodlight masts beyond the walls. Only the
 * real field is dressed (the neon mirror copy 200 m north is left alone).
 * Kit: ./arenaKit.ts; contract bench: agent/bench-extras-arenas.mjs.
 */
import type * as THREE from "three";
import type { MapExtrasContext } from "../mapExtras.js";
import { buildKit, fieldLayout } from "./arenaKit.js";

export const mapIds = ["sandlot"];

export function build(ctx: MapExtrasContext): THREE.Object3D | null {
  return buildKit(ctx, fieldLayout(ctx.map, ctx.lowSpec), "extras:sandlot");
}
